// File: src/pages/PrivacyPage.js
import React from 'react';
import { useProfile } from '../context/ProfileContext';
import PrivacyPolicy202605 from "../components/miscellaneous/PrivacyPolicy202605";

const PrivacyPage = () => {
    const { isDarkMode } = useProfile();

    return (
        /* ✅ Dynamic theme-compliant container background */
        <div className={`min-h-screen transition-colors duration-500 ${isDarkMode ? 'bg-brand-black' : 'bg-white'}`}>
            <div className="max-w-4xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
                
                <div className="text-center">
                    {/* Header typography matches Terms and Copyright page structures */}
                    <h1 className={`text-3xl font-extrabold sm:text-4xl uppercase tracking-tighter italic ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                        Privacy Policy
                    </h1>
                    <p className={`mt-4 text-lg font-bold tracking-widest uppercase text-[10px] ${isDarkMode ? 'text-brand-pink' : 'text-gray-500'}`}>
                        Last updated: May 16, 2026
                    </p>
                </div>

                {/* Prose layer config injecting the custom theme color tokens */}
                <div className={`mt-12 prose prose-lg mx-auto transition-colors duration-500 ${isDarkMode ? 'prose-invert' : ''}`}>
                    
                    <PrivacyPolicy202605 isDarkMode={isDarkMode} />

                </div>

            </div>
        </div>
    );
};

export default PrivacyPage;